export default {
  title: (
    <>
      Invitez vos amis et collectez <br /> des récompenses ensemble
    </>
  ),
  textButton: 'En savoir plus',
};
